import React from 'react';
import CustomerList from './CustomerList';

const PotentialCustomers = () => {
  return <CustomerList filterType="potential" title="Potansiyel Müşteriler" />;
};

export default PotentialCustomers;
